import React from 'react';
import { Calendar, Clock, Globe } from 'lucide-react';

const ScheduleSection = () => {
  return (
    <section className="py-16 md:py-24 bg-teal-600 text-white">
      <div className="container mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
            <div className="space-y-6">
              <div>
              <p className="text-sand-200 font-medium tracking-[0.3em] uppercase text-xs mb-2">
                Расписание
              </p>
              <h2 className="text-3xl md:text-4xl font-serif">
                Доступна почти всегда — в вашем часовом поясе
              </h2>
              <p className="text-sand-100 mt-4 leading-relaxed">
                Я работаю онлайн и подстраиваюсь под ваше время. Окна есть утром, днем
                и поздно вечером — в будни и выходные, чтобы вам было максимально удобно.
              </p>
            </div>
          </div>

          {/* Schedule Cards */}
          <div className="grid sm:grid-cols-3 gap-4">
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 text-center">
              <Clock className="mx-auto mb-3 text-sand-200" size={28} />
              <h4 className="font-semibold text-lg mb-2">Почти 24/7</h4>
              <p className="text-sand-100">Окна для записи есть в разное время суток.</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 text-center">
              <Globe className="mx-auto mb-3 text-sand-200" size={28} />
              <h4 className="font-semibold text-lg mb-2">Любой часовой пояс</h4>
              <p className="text-sand-100">Европа, СНГ, Америка, Азия — подберем время.</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 text-center">
              <Calendar className="mx-auto mb-3 text-sand-200" size={28} />
              <h4 className="font-semibold text-lg mb-2">Гибкое бронирование</h4>
              <p className="text-sand-100">Согласуем время и формат заранее, без спешки.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ScheduleSection;
